import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'uptime' })
export class UptimePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (!value || value < 0) return '-';

    const days = Math.floor(value / 86400);
    const hours = Math.floor((value % 86400) / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const seconds = value % 60;

    let result = '';
    if (days) result += `${days}д `;
    if (hours) result += `${hours}ч `;
    if (minutes) result += `${minutes}м `;
    if (seconds || (!days && !hours && !minutes)) {
      result += `${seconds}с`;
    }

    return result.trim();
  }
}